import React from 'react';
import './Header.css';
import Logo from '../../icons/diamond.png';

const Header = () => {
    return (
        <>
<header className=" md:flex   md:items-center md: p-4 pb-0 md:pb-4">
  
<div class="wrapper">
    <div id="one">
    <img src={Logo} className="flex mr-2" alt="logo diamond real-time chat app" width='32px' height='32px' />
    </div>
    <div className="name flex" id="two">
   Diamond

    </div>
  </div>

</header>
    </>
    )
}

export default Header
